import {
    CTA,
    Container,
    Text,
    TokenTextAppearance,
    Breakpoints,
    TextTag,
} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'
import {closeExternalLinkPopUpLayer} from './launchers/ExternalLinkPupUpLayerHandle'
import {Close} from '@volkswagen-onehub/icons-core'

export const ExternalLinkPopUpLayer = () => {
    const {t} = useTranslation('fa-flotte')

    const title = useSelector(
        (state: RootState) => state.layersHandle.externalLinkPopUp.title
    )

    const text = useSelector(
        (state: RootState) => state.layersHandle.externalLinkPopUp.text
    )

    const ctaText = useSelector(
        (state: RootState) => state.layersHandle.externalLinkPopUp.ctaText
    )

    const ctaUrl = useSelector(
        (state: RootState) => state.layersHandle.externalLinkPopUp.ctaUrl
    )

    return (
        <Container
            padding={{
                top: {
                    [Breakpoints.default]: SizeEnum.static400,
                },
                left: {
                    [Breakpoints.default]: SizeEnum.grid001,
                },
                right: {
                    [Breakpoints.default]: SizeEnum.grid001,
                },
                bottom: {
                    [Breakpoints.default]: SizeEnum.static565,
                },
            }}
            wrap="always"
        >
            <Container horizontalAlign="flex-end">
                <CTA
                    tag="button"
                    emphasis="tertiary"
                    onClick={(e) => {
                        e.preventDefault()
                        closeExternalLinkPopUpLayer()
                    }}
                    aria-label={t('cta.close')}
                    icon={<Close aria-hidden />}
                />
            </Container>

            <Container
                gutter={SizeEnum.static300}
                padding={{
                    bottom: {
                        [Breakpoints.default]: SizeEnum.static400,
                    },
                }}
                wrap="always"
            >
                <Text
                    tag={TextTag.h4}
                    bold
                    appearance={TokenTextAppearance.headline400}
                >
                    {title}
                </Text>
                <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
                    {text}
                </Text>
            </Container>

            <Container horizontalAlign="center">
                <CTA href={ctaUrl} tag="a" emphasis="primary">
                    {ctaText}
                </CTA>
            </Container>
        </Container>
    )
}
